
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface StandardDetailHeaderProps {
  title: string;
  category: string;
  identifier?: string;
  version?: string;
  status: string;
  scope?: string;
  purpose?: string;
}

export function StandardDetailHeader({
  title,
  category,
  identifier,
  version,
  status,
  scope,
  purpose
}: StandardDetailHeaderProps) {
  return (
    <Card className="mb-6 shadow-sm">
      <CardHeader className="pb-2">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2">
          <div>
            <CardTitle className="text-2xl font-bold mb-1">{title}</CardTitle>
            <div className="flex items-center gap-2 mb-3">
              <Badge variant="outline" className="bg-primary/10">{category}</Badge>
              {identifier && (
                <Badge variant="outline" className="font-mono">{identifier}</Badge>
              )}
              {version && (
                <Badge variant="outline" className="bg-muted">v{version}</Badge>
              )}
            </div>
          </div>
          <Badge 
            className={`${
              status === 'Active' 
              ? 'bg-green-100 text-green-800 hover:bg-green-100' 
              : 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100'
            }`}
          >
            {status}
          </Badge>
        </div>
      </CardHeader>
      <CardContent>
        {(scope || purpose) && (
          <div className="space-y-4 mb-2">
            {scope && (
              <div>
                <h3 className="text-sm font-medium text-muted-foreground mb-1">Scope</h3>
                <p className="text-sm">{scope}</p>
              </div>
            )}
            {purpose && (
              <div>
                <h3 className="text-sm font-medium text-muted-foreground mb-1">Purpose</h3>
                <p className="text-sm">{purpose}</p>
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
